// $('').on('change',function(){
//   const num = $(this).prop("selectedIndex");
//   $(this).next().find('.js-select-small').removeClass('show');
//   $(this).next().find('.js-select-small').eq(num).addClass('show');
// });

$(document).on(
  "change",
  ".js-services-title,.js-services-description",
  function() {
    serviceFormCheck(this);
  }
);

if ($(".js-services-title").length > 0) {
  $(".js-services-title,.js-services-description").each(function() {
    serviceFormCheck(this);
  });
}

$(".js-image-search-form").on("submit", function(e) {
  e.preventDefault();
  let keyword = $(this)
    .find("input")
    .val();
  let formNum = $(".js-image-search-form").index($(this));
  $("#loading").fadeIn();
  $.ajax({
    url: "/order/image/search",
    data: {
      keyword: keyword
    },
    timeout: 10000
  })
    .done(function(html) {
      $(".js-image-search-ul")
        .eq(formNum)
        .html(html);
      $("#loading").fadeOut();
    })
    .fail(function(a, b, c) {
      alert("通信に失敗しました。");
      $("#loading").fadeOut();
    });
});

$(".js-image-search-sample li a").on("click", function(e) {
  const text = $(this).html();
  const target = $(this)
    .closest(".js-tab-box")
    .find(".js-image-search-form input");
  target.val(text);
});

$(".js-image-upload-form").on("submit", function(e) {
  let form = $(this);
  let files = form.find("input").prop("files");
  let formNum = $(".js-image-upload-form").index($(this));
  e.preventDefault();
  $("#loading").fadeIn();
  $.ajax({
    url: "/upload/"
  }).done(function(data) {
    var fd = new FormData();
    fd.append("file", files[0]);
    $.ajax({
      url: data.URL,
      type: "POST",
      dataType: "text",
      data: fd,
      processData: false,
      contentType: false,
      xhr: function() {
        let xhr = $.ajaxSettings.xhr();
        // if (xhr.upload) {
        // 	xhr.upload.addEventListener('progress', function(e) {
        // 		let progre = parseInt(e.loaded / e.total * 100);
        // 		if (progre == 100) {
        // 			progre = 99;
        // 		}
        // 		$('.lodging-progress .percentage span').text(progre);
        // 	}, false);
        // }
        return xhr;
      }
    })
      .done(function(text) {
        let data = JSON.parse(text);
        let src = "/serve/?blobKey=" + data.BlobKey;
        $(".js-image-upload-ul")
          .eq(formNum)
          .find("[data-imageid]")
          .data("imageid", "blobkey:" + data.BlobKey);
        $(".js-image-upload-ul")
          .eq(formNum)
          .find("img")
          .attr("src", src)
          .data("src", src);
        $(".js-image-upload-ul")
          .eq(formNum)
          .find("li")
          .show();
        $("#loading").fadeOut();
        // form.submit();
      })
      .fail(function(a, b, c) {
        // $('.lodging-progress').fadeOut('fast');
        $("#loading").fadeOut();
        alert("アップロードに失敗しました。");
      });
  });
  // let keyword = $(this).find('input').val();
  // $.ajax({
  //   url: '/order/image/search',
  //   data: {
  //     keyword: keyword,
  //   }
  // }).done(function(html){
  //   $('#js-image-search-ul').html(html);
  // });
});

function serviceFormCheck(myself) {
  var title = $(myself)
    .closest(".js-services")
    .find(".js-services-title")
    .val();
  var description = $(myself)
    .closest(".js-services")
    .find(".js-services-description")
    .val();

  if (title != "" && description != "") {
    $(myself)
      .closest(".js-services")
      .find(".list-form-business__button")
      .addClass("active");
  } else {
    $(myself)
      .closest(".js-services")
      .find(".list-form-business__button")
      .removeClass("active");
  }

  if (title != "" || description != "") {
    $(myself)
      .closest(".js-services")
      .find("dd.req")
      .addClass("required");
    $(myself)
      .closest(".js-services")
      .find(".js-services-title")
      .eq(0)
      .prop("required", true);
    $(myself)
      .closest(".js-services")
      .find(".js-services-description")
      .eq(0)
      .prop("required", true);
  } else {
    $(myself)
      .closest(".js-services")
      .find("dd.req")
      .removeClass("required");
    $(myself)
      .closest(".js-services")
      .find(".js-services-title")
      .eq(0)
      .prop("required", false);
    $(myself)
      .closest(".js-services")
      .find(".js-services-description")
      .eq(0)
      .prop("required", false);
  }
}
